module.exports = __webpack_public_path__ + "static/media/CTLA_8-178w.57bcce29.jpg";